var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 12L29.3333 8M29.3333 8L25.3333 4M29.3333 8L21.3333 8M21.3333 28V26.4C21.3333 24.1598 21.3333 23.0397 20.8973 22.184C20.5139 21.4314 19.9019 20.8195 19.1493 20.436C18.2936 20 17.1735 20 14.9333 20H9.06666C6.82645 20 5.70634 20 4.85069 20.436C4.09805 20.8195 3.48612 21.4314 3.10263 22.184C2.66666 23.0397 2.66666 24.1598 2.66666 26.4V28M16.6667 10C16.6667 12.5773 14.5773 14.6667 12 14.6667C9.42266 14.6667 7.33332 12.5773 7.33332 10C7.33332 7.42267 9.42266 5.33333 12 5.33333C14.5773 5.33333 16.6667 7.42267 16.6667 10Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsers);
export default __webpack_public_path__ + "static/media/AddUsers.b0ed00393056c7498a592917f49f8ca3.svg";
export { ForwardRef as ReactComponent };